import { api } from "./configs/axiosConfigs"

export const UnitMeasureAPI = {
    
    getUnitMeasure: async (data:any) => {
        const response = await api.get(
            '/unitmeasure', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    createUnitMeasure: async (data: any) => {
        const response = await api.post(
            '/unitmeasure/register', data
        ).then(response => response.data)
        .catch((error) => {
            console.error(error)
            return error.response.data
        })
        return response
    },
    
    editUnitMeasure: async (idstore: number, data: any) => {
        const response = await api.patch(
            `/unitmeasure/${idstore}`, data
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },
    
    deleteUnitMeasure: async (idstore: number) => {
        const response = await api.delete(
            `/unitmeasure/${idstore}`
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },
}